/*
 * Public API Surface of ng-click-outside2
 */

export * from './lib/ng-click-outside.directive';
